import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Btn } from "@/components/ui-bits";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center" data-testid="notfound-page">
      <Seo title="404 — Halaman Tidak Ditemukan | Digitalis" description="Halaman tidak ditemukan." noindex />
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 w-full">
        <p className="overline text-[11px] text-muted-foreground mb-4">Error 404</p>
        <h1 className="font-display font-black tracking-tightest leading-[0.85] text-6xl md:text-8xl lg:text-9xl">Halaman<br />Tidak Ada.</h1>
        <p className="text-muted-foreground text-lg mt-8 max-w-md">Halaman yang Anda cari mungkin sudah dipindahkan atau tidak pernah ada.</p>
        <div className="mt-8"><Btn to="/">Kembali ke Beranda</Btn></div>
      </div>
    </div>
  );
}
